import { render, staticRenderFns } from "./DeviceEditBody.vue?vue&type=template&id=570fe036&scoped=true"
import script from "./DeviceEditBody.vue?vue&type=script&lang=js"
export * from "./DeviceEditBody.vue?vue&type=script&lang=js"
import style0 from "./DeviceEditBody.vue?vue&type=style&index=0&id=570fe036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570fe036",
  null
  
)

export default component.exports